/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeFarmHelperConfigDto,
  ApiEnvelopeFarmHelperEmptyDto,
  FarmHelperConfigRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type farmHelperGetConfigResponse200 = {
  data: ApiEnvelopeFarmHelperConfigDto
  status: 200
}

export type farmHelperGetConfigResponseSuccess = (farmHelperGetConfigResponse200) & {
  headers: Headers;
};
;

export type farmHelperGetConfigResponse = (farmHelperGetConfigResponseSuccess)

export const getFarmHelperGetConfigUrl = (botId: string,) => {




  return `/api/farmhelper/${botId}/config`
}

export const useFarmHelperGetConfigHook = (): (botId: string, options?: RequestInit) => Promise<farmHelperGetConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getFarmHelperGetConfigUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type farmHelperUpsertConfigResponse200 = {
  data: ApiEnvelopeFarmHelperConfigDto
  status: 200
}

export type farmHelperUpsertConfigResponseSuccess = (farmHelperUpsertConfigResponse200) & {
  headers: Headers;
};
;

export type farmHelperUpsertConfigResponse = (farmHelperUpsertConfigResponseSuccess)

export const getFarmHelperUpsertConfigUrl = (botId: string,) => {




  return `/api/farmhelper/${botId}/config`
}

export const useFarmHelperUpsertConfigHook = (): (botId: string,
    farmHelperConfigRequest?: FarmHelperConfigRequest, options?: RequestInit) => Promise<farmHelperUpsertConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    farmHelperConfigRequest?: FarmHelperConfigRequest, options?: RequestInit) => {

        return customFetcher(getFarmHelperUpsertConfigUrl(botId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(farmHelperConfigRequest)
  }
);
      }
  }


export type farmHelperRunResponse200 = {
  data: ApiEnvelopeFarmHelperEmptyDto
  status: 200
}

export type farmHelperRunResponseSuccess = (farmHelperRunResponse200) & {
  headers: Headers;
};
;

export type farmHelperRunResponse = (farmHelperRunResponseSuccess)

export const getFarmHelperRunUrl = (botId: string,) => {




  return `/api/farmhelper/${botId}/run`
}

export const useFarmHelperRunHook = (): (botId: string, options?: RequestInit) => Promise<farmHelperRunResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getFarmHelperRunUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type farmHelperStopResponse200 = {
  data: ApiEnvelopeFarmHelperEmptyDto
  status: 200
}

export type farmHelperStopResponseSuccess = (farmHelperStopResponse200) & {
  headers: Headers;
};
;

export type farmHelperStopResponse = (farmHelperStopResponseSuccess)

export const getFarmHelperStopUrl = (botId: string,) => {




  return `/api/farmhelper/${botId}/stop`
}

export const useFarmHelperStopHook = (): (botId: string, options?: RequestInit) => Promise<farmHelperStopResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getFarmHelperStopUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


